import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import './SlingCheckbox.scss';

class SlingCheckbox extends Component {

  constructor(props) {
    super(props);
    const { defaultChecked } = this.props;
    this.state = { checked: defaultChecked };
    this.toggle = this.toggle.bind(this);
    this.toggleKeyPress = this.toggleKeyPress.bind(this);
  }

  toggle(e) {
    const { checked } = this.state;
    const { onClick } = this.props;
    this.setState({ checked: !checked });
    onClick(e);
  }

  toggleKeyPress(e) {
    const { checked } = this.state;
    const { onClick } = this.props;
    if (e.key === 'Enter' || e.key === ' ') {
      this.setState({ checked: !checked });
      onClick(e);
    }
  }

  render() {
    const { checked } = this.state;
    const { tabIndex, onLabel, offLabel } = this.props;
    return (
      <div
        className="SlingCheckbox"
        role="button"
        tabIndex={tabIndex}
        onClick={this.toggle}
        onKeyDown={this.toggleKeyPress}
      >
        <div
          className={classnames({
            slot: true,
            on: checked,
            off: !checked,
          })}
        >
          <div className="knob" />
        </div>
        <div className="label">
          {checked
            ? onLabel
            : offLabel}
        </div>
      </div>
    );
  }
}

SlingCheckbox.propTypes = {
  defaultChecked: PropTypes.bool,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
};

SlingCheckbox.defaultProps = {
  defaultChecked: false,
  onClick: () => {},
  tabIndex: 0,
  onLabel: 'On',
  offLabel: 'Off',
};

export default SlingCheckbox;
